import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formData: {},
  templateData: {},
  //   loading: false,
  //   error: null,
};

const buyerSlice = createSlice({
  name: "buyer",
  initialState,
  reducers: {
    setBuyerFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setBuyerTemplateData: (state, action) => {
      state.templateData = { ...state.templateData, ...action.payload };
    },
    resetBuyerFormData: (state) => {
      state.formData = {};
    },
    resetBuyerTemplateData: (state, ) => {
      state.templateData = {};
    },
  },
});

export const {
  setBuyerFormData,
  setBuyerTemplateData,
  resetBuyerFormData,
  resetBuyerTemplateData,
} = buyerSlice.actions;

export default buyerSlice.reducer;
